import React, { useEffect, useState } from "react";
import DateInput from "../common/DateInput";
import { ClipLoader } from "react-spinners";
import TimePickerComponent from "../common/TimePickerComponent";
import { sendWebhookAPI, sendWebhookAPI2 } from "../../services/apiServices";
import { useAuthStore } from "../../redux/features/authSlice";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import {
  formatVisitMessage,
  generateMessage,
} from "../../utils/common-function";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const SelectVisitTime = ({
  setIsVisitSelected,
  setRequestData,
  selectedItems,
  selectedISOCode,
}) => {
  const { loginInfo, isLoggedin } = useAuthStore();
  const { propertyInfo } = usePropertyStore();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [visitDates, setVisitDates] = useState([
    {
      id: 1,
      date: "",
      visitTime: [
        {
          id: 1,
          fromTime: "",
          toTime: "",
        },
      ],
    },
  ]);

  const handleAddDate = () => {
    setVisitDates([
      ...visitDates,
      {
        id: visitDates.length + 1,
        date: "",
        visitTime: [
          {
            id: 1,
            fromTime: "",
            toTime: "",
          },
        ],
      },
    ]);
  };

  const handleDeleteDate = (dateId) => {
    if (visitDates.length > 1) {
      setVisitDates(visitDates.filter((date) => date.id !== dateId));
    }
  };

  const handleAddTimeSlot = (dateId) => {
    setVisitDates(
      visitDates.map((date) => {
        if (date.id === dateId) {
          return {
            ...date,
            visitTime: [
              ...date.visitTime,
              {
                id: date.visitTime.length + 1,
                fromTime: "",
                toTime: "",
              },
            ],
          };
        }
        return date;
      })
    );
  };

  const handleDeleteTimeSlot = (dateId, timeId) => {
    setVisitDates(
      visitDates.map((date) => {
        if (date.id === dateId) {
          if (date.visitTime.length > 1) {
            return {
              ...date,
              visitTime: date.visitTime.filter((time) => time.id !== timeId),
            };
          }
        }
        return date;
      })
    );
  };

  const handleDateChange = (id, newDate) => {
    const updatedVisitDates = visitDates.map((dateSlot) =>
      dateSlot.id === id ? { ...dateSlot, date: newDate } : dateSlot
    );
    setVisitDates(updatedVisitDates);
  };

  const handleTimeChange = (dateId, timeSlotId, timeType, newTime) => {
    const updatedVisitDates = visitDates.map((dateSlot) =>
      dateSlot.id === dateId
        ? {
            ...dateSlot,
            visitTime: dateSlot.visitTime.map((timeSlot) =>
              timeSlot.id === timeSlotId
                ? { ...timeSlot, [timeType]: newTime }
                : timeSlot
            ),
          }
        : dateSlot
    );
    setVisitDates(updatedVisitDates);
  };

  const onSubmit = async () => {
    const hasError = toCheckError();
    if (!isLoggedin) {
      toast.warning("You need to log in to continue.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    if (!hasError && isLoggedin) {
      setError("");
      setRequestData(visitDates);
      const countryCodes = [...new Set(selectedISOCode)];
      const message = formatVisitMessage(visitDates);
      setLoading(true);
      try {
        const payload = {
          fullName: loginInfo?.user?.fullname,
          lastName: "",
          email: loginInfo?.user?.email,
          phoneNumber: loginInfo?.user?.phone,
          sizeMin: propertyInfo?.calculatedSize?.size[0],
          sizeMax: propertyInfo?.calculatedSize?.size[1],
          message: message,
          countryCode: `ISO Code of the country where they are searching: ${countryCodes}`,
          selectedProperties: selectedItems,
        };

        const message2 = generateMessage(propertyInfo, loginInfo);

        await sendWebhookAPI2({
          email: loginInfo?.user?.email,
          full_name: loginInfo?.user?.fullname,
          phone_number: loginInfo?.user?.phone,
          space: propertyInfo?.calculatedSize.sizeCount,
          city: "Bucharest",
          body: message2,
          properties: selectedItems,
        });

        const response = await sendWebhookAPI(payload);
        if (response?.data?.statusCode == 200) {
          setIsVisitSelected(false);
        } else {
          console.warn("error coming in webhook in API gives 401");
        }
      } catch (error) {
        console.warn("Error coming in while sending request webhook:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const toCheckError = () => {
    const hasError = visitDates?.some((item) => {
      if (!item?.date) {
        setError("Please select a date.");
        return true;
      }
      const hasErrorTime = item?.visitTime?.some((timeSlot, index) => {
        if (!timeSlot?.fromTime) {
          setError("Please provide a valid 'from' time.");
          return true;
        }
        if (!timeSlot?.toTime) {
          setError("Please provide a valid 'end' time.");
          return true;
        }
        return false;
      });
      return hasErrorTime;
    });
    return hasError;
  };

  //copy time slot
  const handleCopy = async () => {
    try {
      const message = formatVisitMessage(visitDates);
      await navigator.clipboard.writeText(message);
      console.log("Copied:", message);
      // Optional: Show a toast or success message
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
  useEffect(() => {
    const hasError = toCheckError();

    if (!hasError) {
      setError(""); // Clear error if no issues
    }
  }, [visitDates]);

  if (loading)
    return (
      <>
        <div className="flex justify-center h-[100%] items-center">
          <ClipLoader size={40} color="red" />
        </div>
      </>
    );
  return (
    <div>
      <h2 className="text-xl font-bold">Select a Date & Time for Your Visit</h2>

      {visitDates?.map((dateSlot) => (
        <div key={dateSlot.id}>
          <div className="mt-4 flex justify-between">
            <DateInput
              value={dateSlot.date}
              onChange={(newDate) => handleDateChange(dateSlot.id, newDate)}
              minDate={new Date()}
            />
            <div className="flex items-center gap-3">
              <button
                onClick={handleAddDate}
                className="text-red-600 md:text-base text-sm"
              >
                Add
              </button>
              <div className="border-e border-[#C0C0C0] h-full"></div>
              <button
                className="text-secondary md:text-base text-sm"
                onClick={() => handleDeleteDate(dateSlot.id)}
              >
                Delete
              </button>
            </div>
          </div>

          {dateSlot?.visitTime?.map((timeSlot, index) => (
            <div key={timeSlot.id} className="mt-4 flex justify-between">
              <div className="flex items-center md:gap-3 gap-2">
                <TimePickerComponent
                  time={timeSlot.fromTime}
                  onTimeChange={(newTime) =>
                    handleTimeChange(
                      dateSlot.id,
                      timeSlot.id,
                      "fromTime",
                      newTime
                    )
                  }
                  minTime={
                    dateSlot.date
                      ? new Date(dateSlot.date.setHours(0, 0, 0, 0))
                      : new Date()
                  }
                  maxTime={
                    dateSlot.date
                      ? new Date(dateSlot.date.setHours(23, 45, 0, 0))
                      : new Date()
                  }
                />
                <p className="text-[#5D5D5D] md:text-base text-sm text-semibold">
                  to
                </p>
                <TimePickerComponent
                  time={timeSlot.toTime}
                  onTimeChange={(newTime) =>
                    handleTimeChange(
                      dateSlot.id,
                      timeSlot.id,
                      "toTime",
                      newTime
                    )
                  }
                  // minTime={
                  //   timeSlot.fromTime ? new Date(timeSlot.fromTime) : new Date()
                  // }
                  // maxTime={dateSlot.date ? dateSlot.date : new Date()}
                  minTime={
                    dateSlot.date
                      ? new Date(dateSlot.date.setHours(0, 0, 0, 0))
                      : new Date()
                  }
                  maxTime={
                    dateSlot.date
                      ? new Date(dateSlot.date.setHours(23, 45, 0, 0))
                      : new Date()
                  }
                />
              </div>
              <div className="flex items-center gap-4">
                {dateSlot?.visitTime?.length - 1 === index && (
                  <button onClick={() => handleAddTimeSlot(dateSlot.id)}>
                    <i className="fi fi-rr-add text-lg text-red-500"></i>
                  </button>
                )}

                <button onClick={handleCopy}>
                  <i className="fi fi-rr-copy text-lg text-secondary"></i>
                </button>

                <button
                  onClick={() => handleDeleteTimeSlot(dateSlot.id, timeSlot.id)}
                >
                  <i className="fi fi-rr-trash text-lg text-secondary"></i>
                </button>
              </div>
            </div>
          ))}
          <hr className="border-[#C0C0C0] my-3 w-full" />
        </div>
      ))}

      <div className="mt-4 text-right">
        <button
          onClick={() => onSubmit()}
          className="text-white bg-red-600 text-base font-semibold rounded-[45px] px-4 py-2"
        >
          Submit
        </button>
      </div>
      <div className="mt-4 text-right text-red-600">{error && error}</div>
    </div>
  );
};

export default SelectVisitTime;
